import React from 'react';
import Filters from './Filters';
import Traits from './Traits';

export interface FilterProps {
  filters: {
    key: string;
    value: string[];
    count: number;
    options: { value: string; count: number }[];
  }[];
  onFilter: (key: string, value: string) => void;
}

const FiltersContainer = ({ filters, onFilter }: FilterProps) => {
  return (
    <Filters
      traits={filters.map((filter) => (
        <Traits
          key={filter.key}
          name={filter.key}
          value={filter.value}
          options={filter.options}
          onFilter={onFilter}
        />
      ))}
    />
  );
};

export default FiltersContainer;
